import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';
import { useProjectWeeklyReportsUrl } from 'domain/shared/project';
import SingleProjectBreadcrumbs from '../shared/SingleProjectBreadcrumbs';
import { ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const ProjectsWbsDashboardBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getListUrl } = useProjectWeeklyReportsUrl();
  const projectWeeklyReportsListLink = getListUrl();

  return (
    <SingleProjectBreadcrumbs>
      <ListBreadcrumbItem entity="WBS Dashboard" link={projectWeeklyReportsListLink} />
      {children}
    </SingleProjectBreadcrumbs>
  );
};

export default ProjectsWbsDashboardBreadcrumbs;
